import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Query } from "../types/generated/graphql";
import _ from "lodash";

type T = Pick<Query, 'getHistoryScoresOverTime'>;

export const useGetHistoryScoresOverTime = (client: ApolloClient<NormalizedCacheObject>, id: string) => {
  type T = Pick<Query, 'getHistoryScoresOverTime'>;
  const ret = useQuery<T>(QUERY_GET_History_SCORES_OVER_TIME, { 
    client, variables: { id },
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

export const QUERY_GET_History_SCORES_OVER_TIME = gql`
  query fct($id: ID!) {
    getHistoryScoresOverTime(id: $id) {
      dailyScores {
        date
        score
      }
      weeklyScores {
        weekStart
        score
      }
    }
  }
`;